import type { UserFriendlyError } from "../types";

function buildUnavailableMessage(serviceKey: string): UserFriendlyError {
	const serviceMap: Record<string, { title: string; message: string }> = {
		GENAPI: {
			title: "API Genapi indisponible",
			message: "Le service iNot est temporairement indisponible. Veuillez réessayer plus tard.",
		},
		ANNUAIRE: {
			title: "API Annuaire indisponible",
			message: "Le service Annuaire est temporairement indisponible. Veuillez réessayer plus tard.",
		},
		ANCHORAGE: {
			title: "Ancrage impossible",
			message:
				"Le dépôt n'a pas pu être finalisé : l'ancrage du document sur la chaîne n'a pas abouti. Réessayez dans quelques instants ou contactez le notaire si le problème persiste.",
		},
		BITCOIN_SIGNET: {
			title: "Ancrage impossible",
			message:
				"Le dépôt n'a pas pu être finalisé : l'ancrage du document sur la chaîne n'a pas abouti. Réessayez dans quelques instants ou contactez le notaire si le problème persiste.",
		},
	};

	const normalizedServiceKey = serviceKey.toUpperCase();
	const mappedService = serviceMap[normalizedServiceKey];
	if (mappedService) {
		return {
			title: mappedService.title,
			message: mappedService.message,
			canRetry: true,
		};
	}

	return {
		title: "Service externe indisponible",
		message: "Un service externe est temporairement indisponible. Veuillez réessayer plus tard.",
		canRetry: true,
	};
}

const EXTERNAL_SERVICE_UNAVAILABLE_CODE_SUFFIX = "_API_UNAVAILABLE";

/**
 * Résout un code API `SERVICE_API_UNAVAILABLE` (corps JSON backend) vers le libellé toaster.
 */
export function userFriendlyErrorFromExternalServiceApiCode(code: string | null | undefined): UserFriendlyError | null {
	if (!code?.trim()) {
		return null;
	}
	const trimmed = code.trim();
	if (!trimmed.endsWith(EXTERNAL_SERVICE_UNAVAILABLE_CODE_SUFFIX)) {
		return null;
	}
	const serviceKey = trimmed.slice(0, -EXTERNAL_SERVICE_UNAVAILABLE_CODE_SUFFIX.length);
	return buildUnavailableMessage(serviceKey);
}

export const externalServiceErrorPatterns: Array<{
	pattern: RegExp;
	message: UserFriendlyError | ((match: RegExpMatchArray) => UserFriendlyError);
}> = [
	{
		pattern: /([A-Z]+)_API_UNAVAILABLE/i,
		message: (match: RegExpMatchArray): UserFriendlyError => {
			const serviceKey = match[1] || "EXTERNAL";
			return buildUnavailableMessage(serviceKey);
		},
	},
];
